"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomCodeHelper;
(function (CustomCodeHelper) {
    CustomCodeHelper["CallsControllerFunction"] = "CallsControllerFunction";
    CustomCodeHelper["ConsoleOutputDisable"] = "ConsoleOutputDisable";
    CustomCodeHelper["DebugProtectionFunctionCall"] = "DebugProtectionFunctionCall";
    CustomCodeHelper["DebugProtectionFunctionInterval"] = "DebugProtectionFunctionInterval";
    CustomCodeHelper["DebugProtectionFunction"] = "DebugProtectionFunction";
    CustomCodeHelper["DomainLock"] = "DomainLock";
    CustomCodeHelper["SelfDefendingUnicode"] = "SelfDefendingUnicode";
    CustomCodeHelper["StringArrayCallsWrapper"] = "StringArrayCallsWrapper";
    CustomCodeHelper["StringArray"] = "StringArray";
    CustomCodeHelper["StringArrayRotateFunction"] = "StringArrayRotateFunction";
})(CustomCodeHelper = exports.CustomCodeHelper || (exports.CustomCodeHelper = {}));
